import script from "./MarqueeText.vue?vue&type=script&setup=true&lang=js"
export * from "./MarqueeText.vue?vue&type=script&setup=true&lang=js"

import "./MarqueeText.vue?vue&type=style&index=0&id=11da6996&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11da6996"]])

export default __exports__